module.exports = __webpack_public_path__ + "static/media/canverse-small.dbcb1151.png";